import { AxiosRequestConfig } from "axios";
import http from "../base/http.service";
import {
  HesaplamaAracAnketRequestDto,
  FormResponse,
  GrafikAnketRequestDto,
  AnketRequestDto,
  StratejikAnketRequestDto,
  StratejikAnketRaporResponse,
  StratejikAnketKontrolData,
  CevreselGostergelerAnketRequestDto,
  CevreselGostergelerAnketKontrolData,
  CevreselGostergelerAnketRaporResponse
} from "./form.dto";

const services = {
  karbonAyakIziForm(dto: HesaplamaAracAnketRequestDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<FormResponse>("forms/hesaplama", dto, config);
  },
  raporForm(dto: AnketRequestDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<FormResponse>("forms/rapor", dto, config);
  },

  GrafikAnket(dto: GrafikAnketRequestDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<FormResponse>("forms/grafik", dto, config);
  },

  egitimAnket(dto: AnketRequestDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<FormResponse>("forms/egitim", dto, config);
  },
  afadAnket(dto: AnketRequestDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<FormResponse>("forms/afad", dto, config);
  },
  haberAnket(dto: AnketRequestDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<FormResponse>("forms/haber", dto, config);
  },

  // Stratejik anket servisleri
  stratejikAnket(dto: StratejikAnketRequestDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<FormResponse>("forms/stratejik", dto, config);
  },

  stratejikAnketKontrol(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<StratejikAnketKontrolData>("forms/stratejik-kontrol", config);
  },

  stratejikAnketRapor(config?: AxiosRequestConfig<any> | undefined) {
    console.log("stratejikAnketRapor called");
    return http.get<StratejikAnketRaporResponse>("forms/stratejik-rapor", config);
  },

  // Çevresel göstergeler anket servisleri
  cevreselGostergelerAnket(dto: CevreselGostergelerAnketRequestDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<FormResponse>("forms/cevresel-gostergeler", dto, config);
  },

  cevreselGostergelerAnketKontrol(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<CevreselGostergelerAnketKontrolData>("forms/cevresel-gostergeler-kontrol", config);
  },

  cevreselGostergelerAnketRapor(config?: AxiosRequestConfig<any> | undefined) {
    console.log("cevreselGostergelerAnketRapor called");
    return http.get<CevreselGostergelerAnketRaporResponse>("forms/cevresel-gostergeler-rapor", config);
  }
};

export default services;
